import { useTranslation } from 'react-i18next';
import { FileDown, FileText, KeyRound } from 'lucide-react';
import type { Product } from '@/types';
import { ehEntregaDigital } from '@/lib/loja-digital';

const ICONE = { FILE: FileDown, LICENSE_KEY: KeyRound, CONTENT: FileText } as const;

/**
 * Como o comprador recebe um produto digital (página do produto).
 *
 * Location: src/components/digital
 * Why: no jogo a entrega é no servidor; aqui ela chega em "Minhas compras"
 * logo depois do pagamento. A caixa diz isso antes da compra, com o limite de
 * downloads quando há, e some nos produtos de jogo.
 */
export function EntregaDoProduto({ product, className = '' }: { product: Product; className?: string }) {
  const { t } = useTranslation();
  if (!ehEntregaDigital(product.deliveryKind)) return null;
  const tipo = product.deliveryKind as keyof typeof ICONE;
  const Icone = ICONE[tipo] ?? FileDown;
  return (
    <div className={`flex items-start gap-3 rounded-xl border border-border/60 bg-secondary/60 p-3 text-sm ${className}`} data-testid="entrega-digital" data-tipo={tipo}>
      <Icone className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
      <div className="space-y-0.5">
        <p className="font-semibold text-foreground">{t(`store.digital.kind.${tipo}`)}</p>
        <p className="text-muted-foreground">{t(`store.digital.how.${tipo}`)}</p>
        {tipo === 'FILE' && product.downloadLimit ? (
          <p className="text-muted-foreground">{t('store.digital.how.limit', { count: product.downloadLimit })}</p>
        ) : null}
      </div>
    </div>
  );
}
